import api from "api";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { Button, Form, Modal, TextArea } from "semantic-ui-react";
import { OpenAPI } from "simplydo/interfaces";
import { useAppSelector } from "store";

type RequestJoinModalProps = {
  idea: OpenAPI.Schemas["Idea"];
  open: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
}

const RequestJoinModal = ({ idea, open, onClose, onConfirm }: RequestJoinModalProps) => {
  const user = useAppSelector((state) => state.user);
  const [note, setNote] = useState("");

  const handleConfirm = useCallback(() => {
    api.invitations.create({
      forType: "requestJoinIdea",
      forId: idea._id,
      invitee: user._id,
      note,
    }, () => {
      toast.success('Requested to join idea team');
      onClose();
      onConfirm(note);
    }, (err) => {
      toast.error(err.message);
    });
  }, [user, note, idea, onClose, onConfirm]);

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header>Request to join {idea.name}</Modal.Header>
      <Modal.Content>
      <p>
        Send a message to the idea team to request to join the team. You will be able to edit the idea once you have been accepted.
      </p>
      <p>
        Please describe why you would like to join the team, and what you can contribute to the idea below.
      </p>

      <Form>
        <TextArea
          value={note}
          placeholder="I would like to join the team because..."
          onChange={(e) => setNote(e.target.value)}
        />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => onClose()}>Cancel</Button>
        <Button positive onClick={handleConfirm}>Send</Button>
      </Modal.Actions>
    </Modal>
  )
};

export default RequestJoinModal;
